import { createSelector } from 'reselect';
import { returnJS } from 'utils/helpers';
import { initialState } from './reducer';

const selectManageAccountStatusDomain = (state) =>
  state.get('manageAccountStatus', initialState);

const makeSelectUsers = () =>
  createSelector(selectManageAccountStatusDomain, (substate) =>
    returnJS(substate.get('users')),
  );

const makeSelectLoading = () =>
  createSelector(selectManageAccountStatusDomain, (substate) =>
    returnJS(substate.get('loading')),
  );

const makeSelectError = () =>
  createSelector(selectManageAccountStatusDomain, (substate) =>
    returnJS(substate.get('error')),
  );

const makeSelectActionLoading = () =>
  createSelector(selectManageAccountStatusDomain, (substate) =>
    returnJS(substate.get('actionLoading')),
  );

const makeSelectActionError = () =>
  createSelector(selectManageAccountStatusDomain, (substate) =>
    returnJS(substate.get('actionError')),
  );

export default selectManageAccountStatusDomain;
export {
  makeSelectUsers,
  makeSelectLoading,
  makeSelectError,
  makeSelectActionLoading,
  makeSelectActionError,
};
